import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccountSharedModule } from '../../../../account-shared';
import { ShowcaseStoriesComponent } from './components/showcase-stories.component';
import { SHOWCASE_STORIES_FEATURE_NAME, showcaseReducer } from './store';
import { showcaseStoriesEffects } from './store/effects';

@NgModule({
    imports: [
        CommonModule,
        AccountSharedModule,
        StoreModule.forFeature(SHOWCASE_STORIES_FEATURE_NAME, showcaseReducer),
        EffectsModule.forFeature(showcaseStoriesEffects)
    ],
    declarations: [ShowcaseStoriesComponent],
    exports: [ShowcaseStoriesComponent]
})
export class ShowcaseStoriesModule {}
